<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const { isMobile } = useResponsive();
const { closeOnboardingModal } = useModals();
const { currentStep, goNext } = useOnboarding();

// DATA
const title = computed(() => {
    if (currentStep.value === 'Company') return tt('signup.onboarding.company.title');
    if (currentStep.value === 'Info') return tt('signup.onboarding.info.title');
    if (currentStep.value === 'Contact') return tt('signup.onboarding.contact.title');
    if (currentStep.value === 'ThankYou') return tt('signup.onboarding.thankYou.title');
});

// METHODS
const onThankYouCta = (): void => {
    closeOnboardingModal();
};
</script>

<template>
    <UModal :fullscreen="isMobile" :transition="!isMobile" :title="title" :dismissible="false" :close="false" v-bind="modalNoDescAriaFixupProps">
        <slot />
        <template #body>
            <div class="flex flex-col gap-4">
                <template v-if="currentStep">
                    <SignupOnboardingCompanyForm v-if="currentStep === 'Company'" @success="goNext" />
                    <SignupOnboardingInfoForm v-if="currentStep === 'Info'" @next="goNext" />
                    <SignupOnboardingContactForm v-if="currentStep === 'Contact'" @next="goNext" />
                    <template v-if="currentStep === 'ThankYou'">
                        <p class="text-center">{{ tt('signup.onboarding.thankYou.subtitle') }}</p>
                        <UButton :label="tt('signup.onboarding.thankYou.cta')" size="xl" block @click="onThankYouCta" />
                    </template>
                </template>
            </div>
        </template>
    </UModal>
</template>
